import { Component, computed, inject, input } from '@angular/core'

import { Store } from '@ngrx/store'

import { AgentName } from '@flowx/designer/modules/ai/conversation/ai-conversation.commons'
import {
  AgentNameToDocumentTypeMap,
  AiDocumentContentType,
  ChatMessage,
} from '@flowx/designer/modules/ai/types/ai.types'

import { resetInputFileValueFromEvent } from '../../../../common/ai.utils'
import { ConversationActions } from '../../../../conversation/conversation.actions'
import { ConversationSelectors } from '../../../../conversation/conversation.selectors'

@Component({
  selector: 'flx-ai-msg-file-actions',
  imports: [],
  templateUrl: './ai-msg-file-actions.component.html',
  styleUrl: './ai-msg-file-actions.component.scss',
})
export class AiMsgFileActionsComponent {
  #store = inject(Store)

  #uiHintedAction = this.#store.selectSignal(ConversationSelectors.uiHintedAction)

  msgActions = input<ChatMessage['actions']>()

  isUploadDisabled = this.#store.selectSignal(ConversationSelectors.isUploadDisabled)

  showImageUploadAction = computed(() => this.msgActions()?.imageUpload)
  allowedImageFileTypes = this.#store.selectSignal(ConversationSelectors.allowedImageFileTypes)
  isMultipleImageUploadAllowed = this.#store.selectSignal(
    ConversationSelectors.isMultipleImageUploadAllowed
  )

  showBpmnUploadAction = computed(() => this.msgActions()?.bpmnUpload)
  allowedBpmnFileTypes = this.#store.selectSignal(ConversationSelectors.allowedBpmnFileTypes)

  showFromDocumentsAction = computed(() => this.msgActions()?.checkDocumentContext)

  showDocumentUploadAction = computed(() => this.msgActions()?.documentUpload)
  allowedDocumentFileTypes = this.#store.selectSignal(
    ConversationSelectors.allowedDocumentFileTypes
  )
  isMultipleDocumentUploadAllowed = this.#store.selectSignal(
    ConversationSelectors.isMultipleDocumentUploadAllowed
  )

  checkContextDocuments(): void {
    // Ground the "From Documents" picker on the hinted thread agent's document type
    // (create_ui -> screens, business_rule -> rules) instead of always the analyst's
    // business processes. Falls back to the analyst default when no agent is hinted.
    const hintedAgent = this.#uiHintedAction()?.agent as AgentName | undefined
    const resourceType =
      AgentNameToDocumentTypeMap[hintedAgent ?? AgentName.AiAnalyst] ??
      AiDocumentContentType.BUSINESS_PROCESS

    this.#store.dispatch(
      ConversationActions.documentContextOpened({
        resourceType,
        useInCurrentThread: true,
      })
    )
  }

  onFileSelected(event: Event): void {
    this.#store.dispatch(ConversationActions.fileSelectedFromMessage({ event }))
    resetInputFileValueFromEvent(event)
  }
}
